// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1DEzA94LMV5sTnFzzecZrC{flex-grow:1;margin:0 1rem}._1X0t-8yDRwViTQDKtD6uuH{font-size:1.4rem;min-width:7.5rem}._6IXASRyaY0Wb-kVvhjraK{margin-right:.2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bar": "_1DEzA94LMV5sTnFzzecZrC",
	"label": "_1X0t-8yDRwViTQDKtD6uuH",
	"intervals": "_6IXASRyaY0Wb-kVvhjraK"
};
module.exports = ___CSS_LOADER_EXPORT___;
